import { ModelType } from "../models/ModelType.js";
export function getAnalyticsDataForEventProduct(event, product, quantity = 1, price = null, index = null) {
    const data = {
        item_id: `event_product_${product.id}`,
        item_name: `${event.display_name}: ${product.name}`,
        item_category: 'Event',
        item_category2: event.display_name,
        item_category3: 'Event Product',
        quantity: quantity,
    };
    if (event.club) {
        data.item_brand = event.club.display_name;
    }
    if (price !== null) {
        data.price = (Math.round(((price / quantity) / 100) * 100) / 100);
    }
    if (index !== null) {
        data.index = index;
    }
    return data;
}
export function getAnalyticsDataForEventMedia(event, media, quantity = 1, price = null, index = null) {
    const data = {
        item_id: `event_media_${media.id}`,
        item_name: `${event.display_name}: ${media.id}`,
        item_category: 'Event',
        item_category2: event.display_name,
        item_category3: 'Event Media',
        quantity: quantity,
    };
    if (event.club) {
        data.item_brand = event.club.display_name;
    }
    if (price !== null) {
        data.price = (Math.round(((price / quantity) / 100) * 100) / 100);
    }
    if (index !== null) {
        data.index = index;
    }
    return data;
}
export function getAnalyticsDataForParticipationClass(event, participationClass, quantity = 1, price = null, asAdditionalAttempt = false, index = null) {
    const data = {
        item_id: asAdditionalAttempt ? `participation_class_attempt_${participationClass.id}` : `participation_class_${participationClass.id}`,
        item_name: `${event.display_name}:${asAdditionalAttempt ? ' Attempt' : ''} ${participationClass.name}`,
        item_category: 'Event',
        item_category2: event.display_name,
        item_category3: 'Event Participation',
        quantity: quantity,
    };
    if (event.club) {
        data.item_brand = event.club.display_name;
    }
    if (price !== null) {
        data.price = (Math.round(((price / quantity) / 100) * 100) / 100);
    }
    if (index !== null) {
        data.index = index;
    }
    return data;
}
export function getAnalyticsDataForOrderStatement(orderStatement) {
    return orderStatement.analytics ? {
        item_id: orderStatement.analytics.item_id,
        item_name: orderStatement.analytics.name,
        item_brand: orderStatement.analytics.brand,
        item_category: orderStatement.analytics.category,
        item_category2: orderStatement.analytics.category2,
        item_category3: orderStatement.analytics.category3,
        quantity: orderStatement.analytics.quantity,
        coupon: orderStatement.coupon_id ? orderStatement.coupon_id : '',
        price: (orderStatement.gross_paid_amount / 100).toString(),
    } : null;
}
/**
 * @param {object} order
 * @param {array} itemsAnalyticsData
 * @param listId
 * @param listName
 * @return {object}
 */
export function getAnalyticsDataForEcommercePurchaseEvent(order, itemsAnalyticsData, listId = undefined, listName = undefined) {
    return {
        item_list_id: listId,
        item_list_name: listName,
        transaction_id: order.id,
        affiliation: 'SPOFERAN',
        value: order.gross_paid_amount ? (order.gross_paid_amount / 100) : 0,
        tax: order.gross_paid_amount && order.net_paid_amount ? ((order.gross_paid_amount - order.net_paid_amount) / 100) : 0,
        currency: 'EUR',
        items: itemsAnalyticsData
    };
}
/**
 * @param {int} orderId
 * @param {array} items
 * @return {object}
 */
export function getAnalyticsDataForEcommerceRefundEvent(orderId, items = null) {
    const data = {
        transaction_id: orderId,
        currency: 'EUR'
    };
    if (items && items.length) {
        data.items = items.map(item => {
            if (item.model_type === ModelType.EventProductPurchase) {
                return {
                    item_id: `event_product_${item.product_id}`,
                    quantity: item.quantity,
                };
            }
            return {};
        });
    }
    return data;
}
//# sourceMappingURL=analytics-helpers.js.map